import { render } from "./student-learning-path.vue?vue&type=template&id=50cc0cbf"
import script from "./student-learning-path.vue?vue&type=script&lang=js"
export * from "./student-learning-path.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__